import { lightColors } from '@/plugins/colors/base/baseColorsLight'

const notificationTokensLight = {
  'old-notification-error-background': lightColors.oldRed.red,
  'old-notification-success-background': lightColors.oldGreen.green,
}

export default notificationTokensLight
